import { Progress, Skeleton, Typography } from 'antd';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { ShouldRender } from '../../shared/basic/ShouldRender';
import LibraryEmptyState from '../../shared/LibraryEmptyState';
import { BookDummy } from '../../../../assets';
import { Endpoints } from '../../../network';
import { BookInteraction } from '../../../utils/interfaces/Library/Books/MyBook';

interface BooksProps {
  myBookList?: BookInteraction[];
  isLoading: boolean;
  getMyBookListWithSync: () => void;
}

const Books = ({
  myBookList,
  isLoading,
  getMyBookListWithSync,
}: BooksProps) => {
  const router = useRouter();
  const base_Url = process.env.NEXT_PUBLIC_API_READER_URL as string;
  const cardClickHandler = ({
    bookId,
    chapterId,
    chapterPageNumber,
    type,
  }: {
    bookId: string;
    chapterId?: string;
    chapterPageNumber?: number;
    type?: string;
  }) => {
    let url = `pdf/${bookId}`;
    const queryParams = new URLSearchParams();

    if (chapterId) queryParams.append('chapterId', chapterId);
    if (type === 'short') queryParams.append('samplePdf', 'true');
    if (typeof chapterPageNumber === 'number')
      queryParams.append('chapterPageNumber', chapterPageNumber.toString());

    if (!queryParams.keys().next().done) {
      url += `?${queryParams.toString()}`;
    }

    router.push(url);
  };

  return (
    <div className='relative overflow-hidden'>
      <div>
        <div className='flex '>
          <div className='grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 2xl:grid-cols-10 gap-2 w-full md:gap-4'>
            {!isLoading
              ? myBookList?.map((items, index) => {
                  if (items.book.type === 'paperBack') {
                    return <></>;
                  }
                  return (
                    <span
                      onClick={() =>
                        cardClickHandler({
                          bookId: items?.book?._id,
                          chapterId: items?.lastPageRead?.chapter,
                          chapterPageNumber: items?.lastPageRead?.pageNumber,
                          type: items?.book?.type,
                        })
                      }
                      className='group cursor-pointer p-1 sm:p-1.5 no-select'
                      key={`${items?._id}-${index}`}
                    >
                      <Image
                        src={
                          `${base_Url}/${Endpoints.getCoverImagesForBooks}/${items?.book?._id}` ||
                          BookDummy
                        }
                        alt={items?.book?._id}
                        width={180}
                        height={250}
                        className='rounded-md transition-transform transform hover:scale-[1.05] duration-300 
                    '
                      />
                      <ShouldRender check={items.lastPageRead}>
                        <div className='flex flex-col mt-1'>
                          <Progress
                            percent={
                              (items?.lastPageRead?.pageNumber /
                                items?.book?.totalPages) *
                              100
                            }
                            showInfo={false}
                            className='customProcessBar'
                          />
                          <Typography.Title
                            level={3}
                            className='text-textGrayColor text-xs sm:text-sm'
                          >
                            {items?.lastPageRead?.pageNumber} of{' '}
                            {items?.book?.totalPages} Pages
                          </Typography.Title>
                        </div>
                      </ShouldRender>
                    </span>
                  );
                })
              : Array.from({ length: 10 }).map((_, index) => (
                  <div key={index} className='p-1 sm:p-1.5'>
                    <div className='w-full aspect-[3/4]'>
                      <Skeleton.Button
                        active
                        className='w-full h-full rounded-md'
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                  </div>
                ))}
          </div>
        </div>

        <ShouldRender check={!myBookList?.length && !isLoading}>
          <div className='flex w-full justify-center items-center'>
            <LibraryEmptyState
              heading={`Can't see your purchased book?`}
              onPrimaryClick={() => getMyBookListWithSync()}
              onPrimaryText='Refresh'
              onSecondaryClick={() => router.push('/books')}
              desc={
                <span>
                  Tap <b className='inline-flex text-white'>"Refresh"</b> to
                  update your library
                </span>
              }
            />
          </div>
        </ShouldRender>
        <ShouldRender check={myBookList?.length !== 0}>
          <div className='flex w-full justify-center items-center'>
            <LibraryEmptyState
              heading={`Can't see your purchased book?`}
              onPrimaryClick={() => getMyBookListWithSync()}
              onPrimaryText='Refresh'
              noIcon={true}
            />
          </div>
        </ShouldRender>
      </div>
    </div>
  );
};

export default Books;
